(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-board"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.cb').forEach(function (root) {
      var form = root.querySelector('[data-cb-form]');

      // ---- Clean empty price inputs so no blank params are sent ----
      function submitForm() {
        if (!form) return;
        root.querySelectorAll('[data-cb-price]').forEach(function (inp) {
          inp.disabled = (inp.value.trim() === '');
        });
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        // re-enable so values persist visually if navigation is slow
        root.querySelectorAll('[data-cb-price]').forEach(function (inp) { inp.disabled = false; });
      }
      if (form) {
        form.addEventListener('submit', function () {
          root.querySelectorAll('[data-cb-price]').forEach(function (inp) {
            if (inp.value.trim() === '') inp.disabled = true;
          });
        });
      }

      // ---- Sort selects ----
      var sortReal = root.querySelector('[data-cb-sort]');
      if (sortReal) sortReal.addEventListener('change', submitForm);
      var sortProxy = root.querySelector('[data-cb-sortproxy]');
      if (sortProxy) {
        sortProxy.addEventListener('change', function () {
          if (sortReal) { sortReal.value = sortProxy.value; }
          submitForm();
        });
      }

      // ---- Show more (per accordion) ----
      root.querySelectorAll('[data-cb-moretoggle]').forEach(function (btn) {
        var more = btn.previousElementSibling && btn.previousElementSibling.matches('[data-cb-more]')
          ? btn.previousElementSibling
          : (btn.parentElement ? btn.parentElement.querySelector('[data-cb-more]') : null);
        var label = btn.querySelector('[data-cb-morelabel]');
        btn.addEventListener('click', function () {
          if (!more) return;
          var open = more.hasAttribute('hidden');
          if (open) { more.removeAttribute('hidden'); } else { more.setAttribute('hidden', ''); }
          if (label) label.textContent = open ? (btn.getAttribute('data-less-label') || 'Minder tonen') : (btn.getAttribute('data-more-label') || 'Meer');
        });
      });

      // ---- Instant apply (desktop): a filter change reloads with that filter ----
      var desktop = window.matchMedia('(min-width: 750px)');
      function autoApply() { if (desktop.matches) submitForm(); }
      root.querySelectorAll('.cb-opt__input').forEach(function (cbx) {
        cbx.addEventListener('change', autoApply);
      });
      // Price fields apply on Enter (so blur mid-typing doesn't submit prematurely).
      root.querySelectorAll('[data-cb-price]').forEach(function (inp) {
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); submitForm(); }
        });
      });

      // ---- View toggle ----
      var grid = root.querySelector('[data-cb-grid]');
      root.querySelectorAll('[data-cb-view]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-cb-view]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (grid) grid.classList.toggle('cb__grid--list', btn.getAttribute('data-cb-view') === 'list');
        });
      });

      // ---- Mobile bottom sheet ----
      function setSheet(open) {
        root.classList.toggle('cb--sheet-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
        syncFab();
      }
      root.querySelectorAll('[data-cb-open]').forEach(function (b) { b.addEventListener('click', function () { setSheet(true); }); });
      root.querySelectorAll('[data-cb-close]').forEach(function (b) { b.addEventListener('click', function () { setSheet(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSheet(false); });

      // ---- Floating filter pill visibility ----
      var fab = root.querySelector('[data-cb-fab]');
      var seo = root.querySelector('.cb__pager');
      function syncFab() {
        if (!fab) return;
        var scrolled = (window.scrollY || document.documentElement.scrollTop || 0) > 320;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var atEnd = seo ? seo.getBoundingClientRect().top < vh - 40 : false;
        var open = root.classList.contains('cb--sheet-open');
        fab.classList.toggle('is-visible', scrolled && !atEnd && !open);
      }
      window.addEventListener('scroll', syncFab, { passive: true });
      window.addEventListener('resize', syncFab);
      syncFab();

      // ---- Load more (append) ----
      var pager = root.querySelector('.cb__pager');
      var loadBtn = root.querySelector('[data-cb-loadmore]');
      var progress = root.querySelector('[data-cb-progress]');
      var shownEl = root.querySelector('[data-cb-shown]');
      var pages = root.querySelector('[data-cb-pages]');
      var total = pager ? parseInt(pager.getAttribute('data-cb-total'), 10) || 0 : 0;

      function refreshCounts() {
        if (!grid) return;
        var count = grid.querySelectorAll('.cb-card').length;
        if (shownEl) shownEl.textContent = count;
        if (progress && total > 0) progress.style.width = Math.min(100, Math.round((count / total) * 100)) + '%';
      }

      if (loadBtn && grid) {
        loadBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var url = loadBtn.getAttribute('href');
          if (!url || loadBtn.getAttribute('aria-busy') === 'true') return;
          loadBtn.setAttribute('aria-busy', 'true');
          loadBtn.textContent = loadBtn.dataset.loading || 'Laden…';
          if (pages) pages.setAttribute('hidden', '');
          fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-cb-grid]');
              if (newGrid) {
                var frag = document.createDocumentFragment();
                Array.prototype.forEach.call(newGrid.querySelectorAll('.cb-card'), function (li) {
                  frag.appendChild(document.importNode(li, true));
                });
                grid.appendChild(frag);
              }
              var nextBtn = doc.querySelector('[data-cb-loadmore]');
              if (nextBtn && nextBtn.getAttribute('href')) {
                loadBtn.setAttribute('href', nextBtn.getAttribute('href'));
                loadBtn.textContent = loadBtn.dataset.label || 'Laad meer artikelen';
                loadBtn.removeAttribute('aria-busy');
              } else {
                loadBtn.remove();
              }
              refreshCounts();
            })
            .catch(function () {
              loadBtn.textContent = loadBtn.dataset.label || 'Laad meer artikelen';
              loadBtn.removeAttribute('aria-busy');
              window.location.href = url;
            });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-hero"]) return;
  try {
    
  document.querySelectorAll('[data-search-hero]').forEach((form) => {
    const input = form.querySelector('.search-hero__input');
    const clear = form.querySelector('[data-search-clear]');
    if (!input || !clear) return;
    const toggle = () => { clear.style.display = input.value ? 'flex' : 'none'; };
    toggle();
    input.addEventListener('input', toggle);
    clear.addEventListener('click', () => { input.value = ''; toggle(); input.focus(); });
  });

  } catch(e) { console.error(e); }
})();
})();
